import { useEffect, useState } from 'react';
import { BasicLoader, LoaderType } from '../basic-loader';
import i18n from '../../../../i18n/i18n';

export const WaitingLoader = ({
  isLoading,
  children,
  titles = [i18n.t('loader.onIt'), i18n.t('loader.thanks')],
  texts = [i18n.t('loader.pleaseWait'), i18n.t('loader.longer')],
  type,
  hasPadding,
  fullHeight = false,
  topOffset = false,
}: {
  isLoading: boolean;
  children?: JSX.Element;
  titles?: string[];
  texts?: string[];
  type?: LoaderType;
  fullHeight?: boolean;
  topOffset?: boolean;
  hasPadding?: boolean;
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (titles && isLoading) {
      const interval = setInterval(() => {
        setIndex((index) => {
          if (index === titles.length - 1) {
            clearInterval(interval);
            return index;
          }
          return index + 1;
        });
      }, 10000);
      return () => clearInterval(interval);
    }
    return;
  }, [titles, isLoading, index, texts]);

  return isLoading ? (
    <div className={hasPadding ? 'cust-p-3' : ''}>
      <BasicLoader isLoading={isLoading} type={type} fullHeight={fullHeight} topOffset={topOffset} />
      {titles?.length && <h3 className="text-center text-large cust-pb-2 cust-mt-4">{titles[index]}</h3>}
      {texts?.length && <p className="text-center text-regular">{texts[index]}</p>}
    </div>
  ) : (
    children || null
  );
};